import React, {Component, useEffect, useState} from 'react'
import QrReader from 'react-qr-reader'
import "./Scan.scss";
import {Nav} from "../../Components";
// import PouchDB from "pouchdb";
import {CheckinData} from "./ScanServices";
import Rodal from "rodal";
import 'rodal/lib/rodal.css';
import {ConvertToJalali} from "../Customer/CustomerServices";
import moment from "moment-jalaali";
import {useDispatchMall} from "../../hooks/useDispatchMall";
import {useHistory} from "react-router-dom";
import {useMall} from "../../hooks";
import {API} from "../../Services";
import useWindowDimensions from "../../hooks/useWindowDimensions";




function Scan() {

    const [result,setResult] = useState("");
    const [detect,setDetect] = useState(false);
    const [preload, setPreload] = useState(true);
    const [failed, setFailed] = useState(false);
    const [showModal,setShowModal] = useState(false);
    const [showErrorModal,setShowErrorModal] = useState(false);
    const [date,setDate] = useState("");
    const [time,setTime] = useState("");
    const [mallName,setMallName] = useState("");
    const [localMall,setLocalMall] = useState(null);
    const setMall = useDispatchMall();
    const history = useHistory();




    useEffect(()=>{
        //createDb().then();
        // console.log(time);
        let lMall = localStorage.getItem("mall")
        if(lMall)
            setLocalMall(JSON.parse(lMall));

    },[])

    const createDb = async () =>{
        // const db = new PouchDB("inventory");
        // let responseDb = await db.put({_id:'1',title:'heroes'});
    }

    const handleScan = (res) => {
        if(res){
            console.log(res)
            if(res!==result){
                getScan(res);
                setResult(res);
            }
        }
    };

    const getScan = async (result) => {
        try {
            let checkin = await CheckinData(result);
            setPreload(false);


            let splitArray = result.split('_');
            if(splitArray[0] ==="mc"){
                localStorage.setItem('mallId',checkin.data.place_uid);
                localStorage.setItem('mallLogo',checkin.data.place_header_image);
                localStorage.setItem('mallWhite',checkin.data.place_header_logo);
                localStorage.setItem('mallName',checkin.data.place_name);
                localStorage.setItem('mall',JSON.stringify(checkin.data));
                let mallObj ={
                    uid : checkin.data.place_uid,
                    english_name: checkin.data.place_english_name,
                    name: checkin.data.place_name,
                    description: checkin.data.place_description,
                    header_image: checkin.data.place_header_image,
                    logo: checkin.data.place_header_logo,
                }

                setMallName(checkin.data.place_name)
                setMall(mallObj);
            }

            if(splitArray[0] ==="me"){
                setMallName(checkin.data.merchant.name)
            }




            //setDate
            let date = moment(new Date().getTime()).format('jYYYY/jMM/jDD');
            let time = moment(new Date().getTime()).format('HH:mm');
            setDate(date);
            setTime(time);

            setShowModal(true);
        } catch (e) {
            setPreload(false);
            setShowErrorModal(true);
        }
    }




    const handleError = (err) => {
        // console.log(err)
    };
    const { height, width,mobileWidth } = useWindowDimensions();


    return(
        <div  className="scan-container">
            <div className="Error-container">
            <Rodal animation={"zoom"} visible={showErrorModal} onClose={()=>setShowErrorModal(false)}>
                <div className="checkin-modal-container">
                    <div className="checkin-modal-body">
                        <span>کاربر گرامی کد معتبر نمی باشد</span>
                    </div>
                    <div className="checkin-modal-btns">
                        <span onClick={()=>{
                            setShowErrorModal(false)
                        }}>تایید</span>
                    </div>
                </div>
            </Rodal>
            </div>
            <Rodal animation={"zoom"} visible={showModal} onClose={()=>setShowModal(false)}>
                <div className="checkin-modal-container">
                    <div className="checkin-modal-header">
                        <h5> خوش امدید </h5>
                    </div>
                    <div className="checkin-modal-body">
                        <span> به  </span>
                        <span className="mallName">{mallName}</span>
                        <span>خوش آمدید. از ین انتخاب بسیار خرسندیم و لحظات خوشی را برای شما آرزومندیم</span>
                    </div>
                    <div className="checkin-modal-footer">
                        <div className="time">
                            <span className="label">ساعت : </span>
                            <span className="value">{time}</span>
                        </div>
                        <div className="date">
                            <span className="label">تاریخ : </span>
                            <span className="value">{date}</span>
                        </div>
                    </div>
                    <div className="checkin-modal-btns">
                        <span onClick={()=>{
                            history.push("/notifications");
                        }}>تایید</span>
                    </div>
                </div>
            </Rodal>
            <div className="report-header-new" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>
                <img src={localMall?.header_image} alt="" />
            </div>
         <div className="scan-module">
             {!detect?<QrReader
                     delay={300}
                     onError={handleError}
                     onScan={handleScan}
                     style={{ width: '80%' ,borderRadius:44}}
                 />:
                 <div>
                 </div>
             }
         </div>
        <Nav/>
        </div>
    )


}

 export {Scan};
